import { BlueButton, Container, Title } from "styles/Common";
import Stack from "components/Stack";
import styled from "styled-components";

interface props {
  data: IProject;
}

function Contents({ data }: props) {
  return (
    <Cont>
      <Container>
        <Title>{data.title}</Title>
        <Stack data={data.stacks} />

        <ContentsRow dangerouslySetInnerHTML={{ __html: data.description }} />

        <BlueButton>
          <a href={data.url} target={"_blank"}>
            Visit
          </a>
        </BlueButton>
      </Container>
    </Cont>
  );
}

export default Contents;

const Cont = styled.section`
  padding: 30px 0;
  background-color: var(--white);
  color: var(--black);

  p {
    a {
      text-decoration: underline;
    }
  }
`;

const ContentsRow = styled.div`
  padding: 20px 0;
`;
